import { useSale } from '../../../../hooks/sale/useSale';

import POSDateField from '../../../POS/Fields/POSDateField';
import POSInputField from '../../../POS/Fields/POSInputField';

const POSCreditMonthsSection = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================
  const { form, updateField } = useSale();

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div
      className="
        mt-4

        rounded-lg
        border
        border-stroke

        bg-whiten

        p-4

        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      {/* ===================================================== */}
      {/* 🔹 Content */}
      {/* ===================================================== */}
      <div className="space-y-4">
        {/* ===================================================== */}
        {/* 🔹 Due Date */}
        {/* ===================================================== */}
        <POSDateField
          name="paymentCondition.creditDueDate"
          label="Fecha límite"
          iconKey="calendar"
          value={form.paymentCondition?.creditDueDate || ''}
          disabled
          onChange={() => {}}
        />

        {/* ===================================================== */}
        {/* 🔹 Credit Months */}
        {/* ===================================================== */}
        <POSInputField
          name="paymentCondition.creditMonths"
          label="Meses de crédito"
          type="number"
          min={0}
          placeholder="Ej: 3"
          icon="calendar"
          value={form.paymentCondition?.creditMonths ?? ''}
          onChange={(e) => {
            const value = e.target.value.trim();

            if (value === '') {
              updateField('paymentCondition', {
                ...form.paymentCondition,

                creditMonths: undefined,

                creditDueDate: '',
              });

              return;
            }

            const months = Number(value);

            if (form.saleDate && !isNaN(months)) {
              const start = new Date(form.saleDate);

              const dueDate = new Date(start);

              dueDate.setMonth(start.getMonth() + months);

              updateField('paymentCondition', {
                ...form.paymentCondition,

                creditMonths: months,

                creditDueDate: dueDate.toISOString().split('T')[0],
              });
            }
          }}
        />
      </div>
    </div>
  );
};

export default POSCreditMonthsSection;
